<template>
  <lf-button
    class="box-border border border-gray-200 bg-white text-gray-400 shadow-none"
  >
    <slot></slot>
  </lf-button>
</template>
<script setup lang="ts">
import LfButton from "@/components/ui/buttons/LfButton.vue";
</script>
